import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const NAV = [
  { to:'/admin',         icon:'📊', label:'Dashboard' },
  { to:'/admin/books',   icon:'📚', label:'Books' },
  { to:'/admin/users',   icon:'👥', label:'Users' },
];

export default function AdminLayout({ children, title }) {
  const { pathname } = useLocation();
  const { logout }   = useAuth();
  const navigate     = useNavigate();

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'#0a0912' }}>
      {/* Sidebar */}
      <aside style={{ width:230, background:'#0f0e17', borderRight:'1px solid var(--border)', display:'flex', flexDirection:'column', position:'fixed', top:0, left:0, bottom:0, zIndex:50 }}>
        <div style={{ padding:'28px 20px 20px', borderBottom:'1px solid var(--border)' }}>
          <Link to="/" style={{ fontFamily:'var(--font-d)', fontSize:'1.3rem', fontWeight:700, color:'var(--text)', display:'block', marginBottom:8 }}>
            Book<span style={{color:'var(--gold)'}}>Pub</span>
          </Link>
          <span style={{ fontSize:'0.7rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.12em', color:'var(--gold)', background:'rgba(232,197,71,0.1)', padding:'2px 8px', borderRadius:10 }}>Admin Panel</span>
        </div>
        <nav style={{ flex:1, padding:'16px 10px', display:'flex', flexDirection:'column', gap:2 }}>
          {NAV.map(n => {
            const active = pathname === n.to || (n.to !== '/admin' && pathname.startsWith(n.to));
            return (
              <Link key={n.to} to={n.to} style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 12px', borderRadius:8, color: active?'var(--gold)':'var(--text3)', background: active?'rgba(232,197,71,0.08)':'transparent', fontWeight:700, fontSize:'0.83rem', textTransform:'uppercase', letterSpacing:'0.06em', transition:'all 0.15s', textDecoration:'none' }}>
                <span style={{fontSize:'1rem'}}>{n.icon}</span>{n.label}
              </Link>
            );
          })}
        </nav>
        <div style={{ padding:'16px 10px' }}>
          <button onClick={()=>{logout();navigate('/');}} style={{ width:'100%', background:'none', border:'1px solid var(--border2)', borderRadius:8, padding:'10px 12px', color:'var(--text3)', cursor:'pointer', fontFamily:'var(--font-b)', fontSize:'0.83rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.06em', textAlign:'left' }}>
            ↩ Logout
          </button>
        </div>
      </aside>

      {/* Content */}
      <div style={{ flex:1, marginLeft:230, minHeight:'100vh', display:'flex', flexDirection:'column' }}>
        <div style={{ background:'var(--bg2)', borderBottom:'1px solid var(--border)', padding:'20px 32px' }}>
          <h1 style={{ fontFamily:'var(--font-d)', fontSize:'1.5rem', color:'var(--text)', fontWeight:600 }}>{title}</h1>
        </div>
        <div style={{ flex:1, padding:'32px', background:'#0a0912' }}>{children}</div>
      </div>
    </div>
  );
}
